import { useForm } from '@inertiajs/react'
import { useState } from 'react'
import ProjectForm from "./ProjectForm"

interface Project {
  id: number
  title: string
  description: string
  tech_stack: string
  github_url?: string
  demo_url?: string
  image_url?: string
  featured: boolean
  image?: {
    attached?: Array<{ url: string }>
  }
}

interface EditProjectProps {
  project: Project
  onSuccess?: () => void
  onCancel?: () => void
}

const EditProject = ({ project, onSuccess, onCancel }: EditProjectProps) => {
  const [deleteImage, setDeleteImage] = useState(false)
  
  const { data, setData, put, transform, processing, errors, reset } = useForm({
    title: project.title,
    description: project.description,
    tech_stack: project.tech_stack,
    github_url: project.github_url || '',
    demo_url: project.demo_url || '',
    image_url: project.image_url || '',
    featured: project.featured,
    image: project.image || null as File | { attached?: Array<{ url: string }> } | null
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    // Decide what (if anything) to send for the image field. Sending null/""
    // tells Rails' has_one_attached to purge the attachment, so we must only
    // include the key when the user actually picked a new file or asked to
    // delete it - otherwise we omit it so the existing image is left alone.
    transform((formData) => {
      const { image, ...rest } = formData as typeof formData & { image: unknown }
      if (deleteImage) return { ...rest, image: null }
      if (image instanceof File) return { ...rest, image }
      return rest
    })

    put(`/admin/projects/${project.id}`, {
      forceFormData: true,
      onSuccess: () => {
        reset()
        setDeleteImage(false)
        onSuccess?.()
      }
    })
  }

  const handleDeleteImage = () => {
    // Mark image for deletion
    setDeleteImage(true)
    // Clear image_url to ensure no fallback
    setData('image_url', '')
    setData('image', null)
  }

  return (
    <ProjectForm
      data={data}
      setData={setData}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      submitLabel="Update Project"
      processing={processing}
      errors={errors}
      onDeleteImage={handleDeleteImage}
    />
  )
}

export default EditProject 